
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { Ciudad } from '../../domain/model/maestro/entity/ciudad.model';
import { MaestrosEnum } from '../../shared/utils/enums/maestros.enum';
import { TipoIdentificacion } from '../../domain/model/maestro/entity/tipo-identificacion.model';
import { PlanSalud } from '../../domain/model/maestro/entity/plan-salud.model';
import { Piso } from '../../domain/model/maestro/entity/piso.model';
import { Institucion } from '../../domain/model/maestro/entity/institucion.model';
import { Diagnostico } from '../../domain/model/maestro/entity/diagnostico.model';
import { Dosis } from '../../domain/model/maestro/entity/dosis.model';
import { Frecuencia } from '../../domain/model/maestro/entity/frecuencia.model';
import { Medicamento } from '../../domain/model/maestro/entity/medicamento.model';
import { MotivoEgreso } from '../../domain/model/maestro/entity/motivo-egreso.model';
import { MotivosNoAdmision } from '../../domain/model/maestro/entity/motivos-no-admision.model';
import { Municipio } from '../../domain/model/maestro/entity/municipio.model';
import { Peso } from '../../domain/model/maestro/entity/peso.model';
import { Profesional } from '../../domain/model/maestro/entity/profesional.model';
import { ViaAdministracion } from '../../domain/model/maestro/entity/via-administracion.model';

import { environment } from '../../../environments/environment';
import { ComunGatewayAbstract } from '../../domain/model/comun/gateway/comun-gateway.abstract';
import { CausasLlamadaNoContestada } from '../../domain/model/maestro/entity/causa-llamada-no-contestada.model';
import { ClasificacionPermanentes } from '../../domain/model/maestro/entity/clasificacionPermanentes';
import { ConfiguracionInferirPiso } from '../../domain/model/maestro/entity/configuracion-inferir-piso.model';
import { DiagnosticoEspecial } from '../../domain/model/maestro/entity/diagnosticoEspecial';
import { DireccionRequest } from '../../domain/model/maestro/entity/direccion-request';
import { EstadoBandejaDinamica } from '../../domain/model/maestro/entity/estado-bandeja-dinamica.model';
import { EstadoEquipoBiomedico } from '../../domain/model/maestro/entity/estado-equipo-biomedico.model';
import { EstadoPaciente } from '../../domain/model/maestro/entity/estado-paciente.model';
import { Genero } from '../../domain/model/maestro/entity/genero.model';
import { GeoCode } from '../../domain/model/maestro/entity/geo-code';
import { ImagenDiagnostica } from '../../domain/model/maestro/entity/imagen-diagnostica';
import { ConfiguracionInferirSLA } from '../../domain/model/maestro/entity/inferir-sla.model';
import { MotivoAplicacionCuidador } from '../../domain/model/maestro/entity/motivo-aplicacion-cuidador.model';
import { MotivoFijarCita } from '../../domain/model/maestro/entity/motivo-fijar-cita.model';
import { Profesion } from '../../domain/model/maestro/entity/profesion.model';
import { Programa } from '../../domain/model/maestro/entity/programa.model';
import { Proveedor } from '../../domain/model/maestro/entity/proveedor.model';
import { TipoConvenio } from '../../domain/model/maestro/entity/tipo-convenio.model';
import { TipoCuracion } from '../../domain/model/maestro/entity/tipo-curacion.model';
import { TipoEquipoBiomedico } from '../../domain/model/maestro/entity/tipo-equipo-biomedico.model';
import { TipoMuestra } from '../../domain/model/maestro/entity/tipo-muestra.model';
import { TipoNutricion } from '../../domain/model/maestro/entity/tipo-nutricion.model';
import { TipoPlanParticular } from '../../domain/model/maestro/entity/tipo-plan-particular.model';
import { TipoPrestacion } from '../../domain/model/maestro/entity/tipo-prestacion.model';
import { TipoSondajeIngreso } from '../../domain/model/maestro/entity/tipo-sondaje-ingreso.model';
import { TipoSondajeNovedades } from '../../domain/model/maestro/entity/tipo-sondaje-novedades.model';
import { TipoTerapia } from '../../domain/model/maestro/entity/tipo-terapia.model';
import { TipoAtencion } from '../../domain/model/maestro/entity/tipos-atencion.model';
import { TiposSoporteNutricional } from '../../domain/model/maestro/entity/tipos-soporte-nutricional.model';
import { Usuario } from '../../domain/model/maestro/entity/usuario';
import { Valoracion } from '../../domain/model/maestro/entity/valoracion.model';
import { ZonasPorPiso } from '../../domain/model/maestro/entity/zonas-piso.model';
import { Conducta } from '../../domain/model/no-hospitalario/solicitud/entity/conducta.model';
import { PacienteCobertura } from '../../domain/model/remision/dto/paciente-cobertura-dto';


@Injectable({
  providedIn: "root",
})
export class ComunServiceI extends ComunGatewayAbstract {
  consultarCiudad(): Observable<Ciudad[]> {
    throw new Error("Method not implemented.");
  }

  private readonly headers: HttpHeaders;
  private readonly url: string;
  private readonly port: string;

  constructor(private readonly http: HttpClient) {
    super();
    this.headers = new HttpHeaders();
    this.url = `${environment.apiBaseUrl}`;
    this.port = `${environment.portBaseUrl}`;
  }

  public getTiposIdentificacion(): Observable<TipoIdentificacion[]> {
    const url = `${this.url}${this.port}/api_ingreso/maestros/tiposIdentificacion`;
    return this.http
      .get<TipoIdentificacion[]>(url, { withCredentials: true })
      .pipe();
  }

  public getProgramas(): Observable<Programa[]> {
    const url = `${this.url}${this.port}/api_ingreso/maestros/${MaestrosEnum.programas}`;
    return this.http.get<Programa[]>(url, { withCredentials: true }).pipe();
  }

  public getProgramasPorTipoServicio(
    codigoTipoServicio: number,
  ): Observable<Programa[]> {
    const url = `${this.url}${this.port}/api_ingreso/maestros/${MaestrosEnum.programas}/${codigoTipoServicio}`;
    return this.http.get<Programa[]>(url, { withCredentials: true }).pipe();
  }

  public getProgramasAlterno(): Observable<Programa[]> {
    const url = `${this.url}${this.port}/api_ingreso/maestros/${MaestrosEnum.programas}`;
    return this.http.get<Programa[]>(url, { withCredentials: true }).pipe();
  }

  public getTipoConvenios(): Observable<TipoConvenio[]> {
    const url = `${this.url}${this.port}/api_ingreso/opc/consultar-convenios`;
    return this.http.get<TipoConvenio[]>(url, { withCredentials: true }).pipe();
  }

  public verificarRemisionAdmitidaPorPrograma(
    tipoId: string,
    numeroId: string,
    idPrograma: string,
  ): Observable<boolean> {
    const url = `${this.url}${this.port}/api_ingreso/remision/verificarRemisionAdmitida/${tipoId}/${numeroId}/${idPrograma}`;
    return this.http.get<boolean>(url, { withCredentials: true }).pipe();
  }

  public getPisosCiudad(ciudad: string): Observable<Piso[]> {
    const url = `${this.url}${this.port}/api_ingreso/maestros/${MaestrosEnum.pisos}/${ciudad}`;
    return this.http.get<Piso[]>(url, { withCredentials: true }).pipe();
  }

  public getPisosCiudadTipoAtencion(
    ciudad: string[],
    tipoAtencion: string,
    idPrograma: string[],
  ): Observable<Piso[]> {
    if (idPrograma[0] == null) {
      return null;
    }
    const url = `${this.url}${this.port}/api_ingreso/maestros/${MaestrosEnum.pisos}/${ciudad}/${tipoAtencion}/${idPrograma}`;
    return this.http.get<Piso[]>(url, { withCredentials: true }).pipe();
  }

  public getPisosPorCiudadAdmision(
    ciudad: string,
    tipoAtencion: string,
  ): Observable<Piso[]> {
    const url = `${this.url}${this.port}/api_ingreso/maestros/${MaestrosEnum.pisos}/${ciudad}/${tipoAtencion}`;
    return this.http.get<Piso[]>(url, { withCredentials: true }).pipe();
  }

  public getCiudades(): Observable<Ciudad[]> {
    const url = `${this.url}${this.port}/api_ingreso/maestros/${MaestrosEnum.ciudades}`;
    return this.http.get<Ciudad[]>(url, { withCredentials: true }).pipe();
  }

  public getPriorizaciones(): Observable<any[]> {
    const url = `${this.url}${this.port}/api_ingreso/maestros/priorizaciones`;
    return this.http.get<any[]>(url, { withCredentials: true }).pipe();
  }

  consultarTipoAtencionPorCodigo(
    codigoTipo: number,
  ): Observable<TipoAtencion[]> {
    const url = `${this.url}${this.port}/api_ingreso/maestros/tipoAtencionPorCodigoTipo/${codigoTipo}`;
    return this.http.get<TipoAtencion[]>(url);
  }

  public getTiposAtencion(): Observable<TipoAtencion[]> {
    const url = `${this.url}${this.port}/api_ingreso/maestros/tiposAtencion`;
    return this.http.get<TipoAtencion[]>(url, { withCredentials: true }).pipe();
  }

  public getDatosPaciente(
    tipoDocumento: string,
    documento: string,
  ): Observable<PacienteCobertura> {
    const url = `${this.url}${this.port}/api_ingreso/paciente/${tipoDocumento}/${documento}`;
    return this.http.get<PacienteCobertura>(url).pipe();
  }

  public getConsentimiento(
    nombre: string,
    documento: string,
  ): Observable<string> {
    const url = `${this.url}${this.port}/api_ingreso/consentimiento/${nombre}/${documento}`;
    return this.http
      .get(url, { responseType: "text", withCredentials: true })
      .pipe();
  }

  public getPeso(): Observable<Peso[]> {
    const url = `${this.url}${this.port}/api_ingreso/maestros/${MaestrosEnum.peso}`;
    return this.http.get<Peso[]>(url, { withCredentials: true }).pipe();
  }

  getGenero(): Observable<Genero[]> {
    const url = `${this.url}${this.port}/api_ingreso/maestros/${MaestrosEnum.generos}`;
    return this.http.get<Genero[]>(url, { withCredentials: true }).pipe();
  }

  public getProfesional(
    tipoDocumento: string,
    numeroDocumento: string,
  ): Observable<Profesional> {
    const url = `${this.url}${this.port}/api_ingreso/profesional/${tipoDocumento}/${numeroDocumento}`;
    return this.http.get<Profesional>(url, { withCredentials: true }).pipe();
  }

  public getPaciente(
    tipoDocumento: string,
    numeroDocumento: string,
  ): Observable<PacienteCobertura> {
    const url = `${this.url}${this.port}/api_ingreso/paciente/${tipoDocumento}/${numeroDocumento}`;
    return this.http.get<PacienteCobertura>(url, { withCredentials: true }).pipe();
  }

  getXYY(dataDireccion: DireccionRequest): Observable<GeoCode> {
    const url = `https://sitidata-stdr.appspot.com/api/geocoder`;
    return this.http
      .post<GeoCode>(url, dataDireccion, {
        headers: new HttpHeaders()
          .set("Content-Type", "application/json")
          .set("Authorization", "Token 4MHKKJDUW9Z07AIV2WH12FRGA4W8CD"),
      })
      .pipe();
  }

  getDetallesDeLugares(nombre: string, ciudad: string): Observable<any> {
    const url = `${this.url}${this.port}/api_novedades/maestros/coordenadas`;
    return this.http
      .post<any>(url, { nombre, ciudad }, { withCredentials: true })
      .pipe();
  }

  getXYYGoogle(dataDireccion: DireccionRequest): Observable<GeoCode> {
   
    const url = `https://maps.googleapis.com/maps/api/js?key=AIzaSyAT0u-FE0w3y0MsrjKD-YQtsEyhyKzOmJY&libraries=places&callback=initAutocomplete`;
    return this.http
      .post<GeoCode>(url, dataDireccion, {
        headers: new HttpHeaders().set(
          "Authorization",
          "Token 4MHKKJDUW9Z07AIV2WH12FRGA4W8CD",
        ),
      })
      .pipe();
  }

  public getDosis(tipo: string): Observable<Dosis[]> {
    const URL = `${this.url}${this.port}/api_ingreso/maestros/dosis/${tipo}`;

    return this.http.get<Dosis[]>(URL, { withCredentials: true }).pipe();
  }

  public getFrecuencias(tipo: string): Observable<Frecuencia[]> {
    const URL = `${this.url}${this.port}/api_ingreso/maestros/frecuencias/${tipo}`;
    return this.http.get<Frecuencia[]>(URL, { withCredentials: true }).pipe();
  }

  public getMedicamentos(filtro: string): Observable<Medicamento[]> {
    const URL = `${this.url}${this.port}/api_ingreso/maestros/medicamentos`;
    const params = { filtro };
    return this.http
      .get<Medicamento[]>(URL, { params, withCredentials: true })
      .pipe();
  }

  public getGeoReferenciacion(): Observable<any[]> {
    const URL = `${this.url}${this.port}/api_ingreso/maestros/georeferenciacion`;
    return this.http.get<any[]>(URL, { withCredentials: true }).pipe();
  }

  public getMotivosCancelacion(): Observable<MotivosNoAdmision[]> {
    const URL = `${this.url}${this.port}/api_ingreso/maestros/motivosCancelacion`;
    return this.http
      .get<MotivosNoAdmision[]>(URL, { withCredentials: true })
      .pipe();
  }

  public getValoraciones(): Observable<Valoracion[]> {
    const URL = `${this.url}${this.port}/api_ingreso/maestros/valoraciones`;
    return this.http.get<Valoracion[]>(URL, { withCredentials: true }).pipe();
  }

  public getValoracionesPorTipo(tipo: string): Observable<Valoracion[]> {
    const URL = `${this.url}${this.port}/api_ingreso/maestros/valoraciones/${tipo}`;
    return this.http.get<Valoracion[]>(URL, { withCredentials: true }).pipe();
  }

  public getTiposNutricion(): Observable<TipoNutricion[]> {
    const URL = `${this.url}${this.port}/api_ingreso/maestros/tiposNutricion`;
    return this.http
      .get<TipoNutricion[]>(URL, { withCredentials: true })
      .pipe();
  }

  public getSedes(idPiso: string): Observable<any[]> {
    const url = `${this.url}${this.port}/api_ingreso/maestros/sedesSaludEnCasa/${idPiso}`;
    return this.http.get<any[]>(url, { withCredentials: true }).pipe();
  }

  public consultarTipoMuestra(): Observable<TipoMuestra[]> {
    const URL = `${this.url}${this.port}/api_ingreso/maestros/tiposMuestra`;
    return this.http.get<TipoMuestra[]>(URL, { withCredentials: true }).pipe();
  }

  /********************************************************NOVEDADES*****************************************************/

  public getTiposIdentificacionNovedad(): Observable<TipoIdentificacion[]> {
    const url = `${this.url}${this.port}/api_novedades/maestros/tiposIdentificacion`;
    return this.http
      .get<TipoIdentificacion[]>(url, { withCredentials: true })
      .pipe();
  }

  public getCiudadesNovedad(): Observable<Ciudad[]> {
    const url = `${this.url}${this.port}/api_novedades/maestros/${MaestrosEnum.ciudades}`;
    return this.http.get<Ciudad[]>(url, { withCredentials: true }).pipe();
  }

  public getProgramasNovedad(): Observable<Programa[]> {
    const url = `${this.url}${this.port}/api_novedades/maestros/${MaestrosEnum.programas}`;
    return this.http.get<Programa[]>(url, { withCredentials: true }).pipe();
  }

  public getMunicipiosNovedad(idCiudad: string): Observable<Municipio[]> {
    const url = `${this.url}${this.port}/api_novedades/maestros/${MaestrosEnum.municipios}/${idCiudad}`;
    return this.http.get<Municipio[]>(url, { withCredentials: true }).pipe();
  }

  public getCentroDeEstadiaTemporal(idCiudad: string): Observable<any[]> {
    const URL = `${this.url}${this.port}/api_ingreso/maestros/centrotemporal/${idCiudad}`;
    return this.http.get<any[]>(URL, { withCredentials: true }).pipe();
  }

  public getPisosCiudadNovedad(idCiudad: string): Observable<Piso[]> {
    const url = `${this.url}${this.port}/api_novedades/maestros/${MaestrosEnum.pisos}/${idCiudad}`;
    return this.http.get<Piso[]>(url, { withCredentials: true }).pipe();
  }

  public getPisosCiudadTipoAtencionNovedad(
    ciudad: string,
    tipoAtencion: string,
    idPrograma: string,
  ): Observable<Piso[]> {
    const url = `${this.url}${this.port}/api_novedades/maestros/${MaestrosEnum.pisos}/${ciudad}/${tipoAtencion}/${idPrograma}`;
    return this.http.get<Piso[]>(url, { withCredentials: true }).pipe();
  }

  public getDosisNovedad(tipo: string): Observable<Dosis[]> {
    const URL = `${this.url}${this.port}/api_novedades/maestros/dosis/${tipo}`;

    return this.http.get<Dosis[]>(URL, { withCredentials: true }).pipe();
  }

  public getFrecuenciasNovedad(tipo: string): Observable<Frecuencia[]> {
    const URL = `${this.url}${this.port}/api_novedades/maestros/frecuencias/${tipo}`;

    return this.http.get<Frecuencia[]>(URL, { withCredentials: true }).pipe();
  }

  public getMedicamentosNovedad(filtro: string): Observable<Medicamento[]> {
    const URL = `${this.url}${this.port}/api_novedades/maestros/medicamentos`;
    const params = { filtro };
    return this.http
      .get<Medicamento[]>(URL, { params, withCredentials: true })
      .pipe();
  }

  public getTiposNutricionNovedad(): Observable<TipoNutricion[]> {
    const URL = `${this.url}${this.port}/api_novedades/maestros/tiposNutricion`;
    return this.http
      .get<TipoNutricion[]>(URL, { withCredentials: true })
      .pipe();
  }

  public getTiposCuracionesNovedad(): Observable<TipoCuracion[]> {
    const URL = `${this.url}${this.port}/api_novedades/maestros/tiposCuracion`;
    return this.http.get<TipoCuracion[]>(URL, { withCredentials: true }).pipe();
  }

  getTiposSondajeNovedad(): Observable<TipoSondajeNovedades[]> {
    const URL = `${this.url}${this.port}/api_novedades/maestros/tiposSondaje`;
    return this.http
      .get<TipoSondajeNovedades[]>(URL, { withCredentials: true })
      .pipe();
  }

  public getTiposTerapiasNovedad(): Observable<TipoTerapia[]> {
    const URL = `${this.url}${this.port}/api_novedades/maestros/tiposTerapia`;
    return this.http.get<TipoTerapia[]>(URL, { withCredentials: true }).pipe();
  }

  public getProfesionesNovedad(): Observable<Profesion[]> {
    const URL = `${this.url}${this.port}/api_novedades/maestros/profesiones`;
    return this.http.get<Profesion[]>(URL, { withCredentials: true }).pipe();
  }

  public getProfesionesNovedadIdPrograma(
    idPrograma: string,
  ): Observable<Profesion[]> {
    const URL = `${this.url}${this.port}/api_novedades/maestros/profesiones/${idPrograma}`;
    return this.http.get<Profesion[]>(URL, { withCredentials: true }).pipe();
  }

  public getTomasMuestraNovedad(): Observable<TipoMuestra[]> {
    const URL = `${this.url}${this.port}/api_novedades/maestros/tiposMuestra`;
    return this.http.get<TipoMuestra[]>(URL, { withCredentials: true }).pipe();
  }

  public getTiposTomasMuestraNovedad(): Observable<TipoMuestra[]> {
    const URL = `${this.url}${this.port}/api_novedades/maestros/tiposTomaMuestra`;
    return this.http.get<TipoMuestra[]>(URL, { withCredentials: true }).pipe();
  }

  public getTipoEquiposBiomedicosNovedad(): Observable<TipoEquipoBiomedico[]> {
    const URL = `${this.url}${this.port}/api_novedades/maestros/tipoEquipoBioMedicos`;
    return this.http
      .get<TipoEquipoBiomedico[]>(URL, { withCredentials: true })
      .pipe();
  }

  public getEstadosEquiposBiomedicosNovedad(
    idEstado: string,
    nombreUsuario: string,
  ): Observable<EstadoEquipoBiomedico[]> {
    const URL = `${this.url}${this.port}/api_novedades/equipoBioMedicos/consultarEstados/${idEstado}/${nombreUsuario}`;
    return this.http
      .get<EstadoEquipoBiomedico[]>(URL, { withCredentials: true })
      .pipe();
  }

  public getMotivosAplicacionCuidadorNovedad(): Observable<
    MotivoAplicacionCuidador[]
  > {
    const URL = `${this.url}${this.port}/api_novedades/maestros/motivosAplicacionCuidador`;
    return this.http
      .get<MotivoAplicacionCuidador[]>(URL, { withCredentials: true })
      .pipe();
  }

  public getProveedoresEquiposBiomedicosNovedad(
    estado: string,
  ): Observable<Proveedor[]> {
    const URL = `${this.url}${this.port}/api_novedades/maestros/proveedores/${estado}`;
    return this.http.get<Proveedor[]>(URL, { withCredentials: true }).pipe();
  }

  getUsuariosProveedoresEquiposBiomedicosNovedad(): Observable<any> {
    const URL = `${this.url}${this.port}/api_novedades/equiposBioMedicos/consultarUsuariosProveedores`;
    return this.http.get<any>(URL, { withCredentials: true }).pipe();
  }

  public getLlamadaNoContestada(): Observable<CausasLlamadaNoContestada[]> {
    const URL = `${this.url}${this.port}/api_novedades/maestros/llamadaNoContestada`;
    return this.http.get<CausasLlamadaNoContestada[]>(URL, {
      withCredentials: true,
    });
  }

  public getEstadosPacienteNovedad(): Observable<EstadoPaciente[]> {
    const url = `${this.url}${this.port}/api_novedades/maestros/estadoPaciente`;
    return this.http
      .get<EstadoPaciente[]>(url, { withCredentials: true })
      .pipe();
  }

  public getGeoReferenciacionNovedad(): Observable<any[]> {
    const URL = `${this.url}${this.port}/api_novedades/maestros/georeferenciacion`;
    return this.http.get<any[]>(URL, { withCredentials: true }).pipe();
  }

  public getEstadosBandejaDinamica(): Observable<EstadoBandejaDinamica[]> {
    const url = `${this.url}${this.port}/api_novedades/bandejaDinamica/estados`;
    return this.http
      .get<EstadoBandejaDinamica[]>(url, { withCredentials: true })
      .pipe();
  }

  public getImagenesDiagnosticas(): Observable<ImagenDiagnostica[]> {
    const URL = `${this.url}${this.port}/api_novedades/maestros/tipoAyudasDiagnosticas`;
    return this.http
      .get<ImagenDiagnostica[]>(URL, { withCredentials: true })
      .pipe();
  }

  public consultarDosis(): Observable<Dosis[]> {
    const URL = `${this.url}${this.port}/api_maestros/consultarDosis`;
    return this.http.get<Dosis[]>(URL, { withCredentials: true }).pipe();
  }

  public consultarDiagnostico(): Observable<Diagnostico[]> {
    const URL = `${this.url}${this.port}/api_maestros/consultarDiagnostico`;
    return this.http.get<Diagnostico[]>(URL, { withCredentials: true }).pipe();
  }

  public consultarFrecuencia(): Observable<Frecuencia[]> {
    const URL = `${this.url}${this.port}/api_maestros/consultarFrecuencia`;
    return this.http.get<Frecuencia[]>(URL, { withCredentials: true }).pipe();
  }

  public consultarInstitucion(): Observable<Institucion[]> {
    const URL = `${this.url}${this.port}/api_maestros/consultarInstitucion`;
    return this.http.get<Institucion[]>(URL, { withCredentials: true }).pipe();
  }

  public consultarMedicamento(): Observable<Medicamento[]> {
    const URL = `${this.url}${this.port}/api_maestros/consultarMedicamento`;
    return this.http.get<Medicamento[]>(URL, { withCredentials: true }).pipe();
  }

  public consultarMotivoCancelacion(): Observable<MotivosNoAdmision[]> {
    const URL = `${this.url}${this.port}/api_maestros/consultarMotivoCancelacion`;
    return this.http
      .get<MotivosNoAdmision[]>(URL, { withCredentials: true })
      .pipe();
  }

  public consultarMunicipio(): Observable<Municipio[]> {
    const URL = `${this.url}${this.port}/api_maestros/consultarMunicipio`;
    return this.http.get<Municipio[]>(URL, { withCredentials: true }).pipe();
  }

  public consultarPiso(): Observable<Piso[]> {
    const URL = `${this.url}${this.port}/api_maestros/consultarPiso`;
    return this.http.get<Piso[]>(URL, { withCredentials: true }).pipe();
  }

  public consultarPlanSalud(): Observable<PlanSalud[]> {
    const URL = `${this.url}${this.port}/api_maestros/consultarPlanSalud`;
    return this.http.get<PlanSalud[]>(URL, { withCredentials: true }).pipe();
  }

  public consultarTipoNutricion(): Observable<TipoNutricion[]> {
    const URL = `${this.url}${this.port}/api_maestros/consultarTipoNutricion`;
    return this.http
      .get<TipoNutricion[]>(URL, { withCredentials: true })
      .pipe();
  }

  public consultarTipoIdentificacion(): Observable<TipoIdentificacion[]> {
    const URL = `${this.url}${this.port}/api_maestros/consultarTipoIdentificacion`;
    return this.http
      .get<TipoIdentificacion[]>(URL, { withCredentials: true })
      .pipe();
  }

  public consultarTipoSoporteNutricional(): Observable<
    TiposSoporteNutricional[]
  > {
    const URL = `${this.url}${this.port}/api_maestros/consultarTipoSoporteNutricional`;
    return this.http
      .get<TiposSoporteNutricional[]>(URL, { withCredentials: true })
      .pipe();
  }

  public consultarViaAdministracion(): Observable<ViaAdministracion[]> {
    const URL = `${this.url}${this.port}/api_maestros/consultarViaAdministracion`;
    return this.http
      .get<ViaAdministracion[]>(URL, { withCredentials: true })
      .pipe();
  }

  public consultarCausasLlamadas(): Observable<CausasLlamadaNoContestada[]> {
    const URL = `${this.url}${this.port}/api_maestros/consultarCausasLlamadas`;
    return this.http
      .get<CausasLlamadaNoContestada[]>(URL, { withCredentials: true })
      .pipe();
  }

  public consultarEstadoPaciente(): Observable<EstadoPaciente[]> {
    const URL = `${this.url}${this.port}/api_maestros/consultarEstadoPaciente`;
    return this.http
      .get<EstadoPaciente[]>(URL, { withCredentials: true })
      .pipe();
  }

  public consultarMotivoAplicacionCuidador(): Observable<
    MotivoAplicacionCuidador[]
  > {
    const URL = `${this.url}${this.port}/api_maestros/consultarMotivoAplicacionCuidador`;
    return this.http
      .get<MotivoAplicacionCuidador[]>(URL, { withCredentials: true })
      .pipe();
  }

  public consultarMotivoFijarCita(): Observable<MotivoFijarCita[]> {
    const URL = `${this.url}${this.port}/api_maestros/consultarMotivoFijarCita`;
    return this.http
      .get<MotivoFijarCita[]>(URL, { withCredentials: true })
      .pipe();
  }

  public consultarNovedadPorTipoAdmision(): Observable<any[]> {
    const URL = `${this.url}${this.port}/api_maestros/consultarNovedadPorTipoAdmision`;
    return this.http.get<any[]>(URL, { withCredentials: true }).pipe();
  }

  public consultarPermisosTerceros(): Observable<any[]> {
    const URL = `${this.url}${this.port}/api_maestros/consultarPermisosTerceros`;
    return this.http.get<any[]>(URL, { withCredentials: true }).pipe();
  }

  public consultarProveedor(): Observable<Proveedor[]> {
    const URL = `${this.url}${this.port}/api_maestros/consultarProveedor`;
    return this.http.get<Proveedor[]>(URL, { withCredentials: true }).pipe();
  }

  public consultarTipoCuracion(): Observable<TipoCuracion[]> {
    const URL = `${this.url}${this.port}/api_maestros/consultarTipoCuracion`;
    return this.http.get<TipoCuracion[]>(URL, { withCredentials: true }).pipe();
  }

  public consultarSedesSaludEnCasa(): Observable<any[]> {
    const URL = `${this.url}${this.port}/api_maestros/consultarSedesSaludEnCasa`;
    return this.http.get<any[]>(URL, { withCredentials: true }).pipe();
  }

  public consultarTipoEquipoMedico(): Observable<TipoEquipoBiomedico[]> {
    const URL = `${this.url}${this.port}/api_maestros/consultarTipoEquipoMedico`;
    return this.http
      .get<TipoEquipoBiomedico[]>(URL, { withCredentials: true })
      .pipe();
  }

  public consultarTipoTerapia(): Observable<TipoTerapia[]> {
    const URL = `${this.url}${this.port}/api_maestros/consultarTipoTerapia`;
    return this.http.get<TipoTerapia[]>(URL, { withCredentials: true }).pipe();
  }

  public consultarTipoPlanParticular(): Observable<any[]> {
    const URL = `${this.url}${this.port}/api_maestros/consultarTipoPlanParticular`;
    return this.http.get<any[]>(URL, { withCredentials: true }).pipe();
  }

  public consultarPrograma(): Observable<Programa[]> {
    const URL = `${this.url}${this.port}/api_maestros/consultarPrograma`;
    return this.http.get<Programa[]>(URL, { withCredentials: true }).pipe();
  }

  public consultarProfesional(): Observable<Profesional[]> {
    const URL = `${this.url}${this.port}/api_maestros/consultarProfesional`;
    return this.http.get<Profesional[]>(URL, { withCredentials: true }).pipe();
  }

  public consultarValoraciones(): Observable<Valoracion[]> {
    const URL = `${this.url}${this.port}/api_maestros/consultarValoraciones`;
    return this.http.get<Valoracion[]>(URL, { withCredentials: true }).pipe();
  }

  public consultarTipoSondajeIngreso(): Observable<TipoSondajeIngreso[]> {
    const URL = `${this.url}${this.port}/api_maestros/consultarTipoSondajeIngreso`;
    return this.http
      .get<TipoSondajeIngreso[]>(URL, { withCredentials: true })
      .pipe();
  }

  public consultarValidacionOPC(): Observable<any[]> {
    const URL = `${this.url}${this.port}/api_maestros/consultarValidacionOPC`;
    return this.http.get<any[]>(URL, { withCredentials: true }).pipe();
  }

  public consultarMotivoEgreso(): Observable<MotivoEgreso[]> {
    const URL = `${this.url}${this.port}/api_maestros/consultarMotivoEgreso`;
    return this.http.get<MotivoEgreso[]>(URL, { withCredentials: true }).pipe();
  }

  public consultarTipoSondajeNovedades(): Observable<TipoSondajeNovedades[]> {
    const URL = `${this.url}${this.port}/api_maestros/consultarTipoSondajeNovedades`;
    return this.http
      .get<TipoSondajeNovedades[]>(URL, { withCredentials: true })
      .pipe();
  }

  getProfesionesEnfermeriaIdPrograma(
    idPrograma: string,
  ): Observable<Profesion[]> {
    const URL = `${this.url}${this.port}/api_novedades/maestros/profesionesEnfermeria/${idPrograma}`;
    return this.http.get<Profesion[]>(URL, { withCredentials: true }).pipe();
  }

  public obtenerClasificacionPermanentes(): Observable<
    ClasificacionPermanentes[]
  > {
    const URL = `${this.url}${this.port}/api_novedades/maestros/clasificacionesPermanentes`;
    return this.http
      .get<ClasificacionPermanentes[]>(URL, { withCredentials: true })
      .pipe();
  }

  ///// Comunes /////

  public getInstituciones(idCiudad: string): Observable<Institucion[]> {
    const URL = `${this.url}${this.port}/api_ingreso/maestros/instituciones/${idCiudad}`;
    return this.http.get<Institucion[]>(URL, { withCredentials: true }).pipe();
  }

  public getDiagnosticos(nombre: string): Observable<Diagnostico[]> {
    const URL = `${this.url}${this.port}/api_ingreso/maestros/diagnosticos/${nombre}`;
    return this.http.get<Diagnostico[]>(URL, { withCredentials: true }).pipe();
  }

  public getDiagnosticosNovedad(nombre: string): Observable<Diagnostico[]> {
    const URL = `${this.url}${this.port}/api_novedades/maestros/diagnosticos/${nombre}`;
    return this.http.get<Diagnostico[]>(URL, { withCredentials: true }).pipe();
  }

  public getDiagnosticosEspeciales(): Observable<DiagnosticoEspecial[]> {
    const URL = `${this.url}${this.port}/api_ingreso/maestros/diagnosticosEspeciales`;
    return this.http
      .get<DiagnosticoEspecial[]>(URL, { withCredentials: true })
      .pipe();
  }

  public getTiposSoporteNutricional(): Observable<TiposSoporteNutricional[]> {
    const URL = `${this.url}${this.port}/api_ingreso/maestros/tiposSoporteNutricional`;
    return this.http
      .get<TiposSoporteNutricional[]>(URL, { withCredentials: true })
      .pipe();
  }

  //// Ingreso /////////

  public getTipoPlanParticular(): Observable<TipoPlanParticular[]> {
    const URL = `${this.url}${this.port}/api_ingreso/maestros/tiposPlanParticular`;
    return this.http
      .get<TipoPlanParticular[]>(URL, { withCredentials: true })
      .pipe();
  }

  public getPlanesSalud(): Observable<PlanSalud[]> {
    const URL = `${this.url}${this.port}/api_ingreso/maestros/planesSalud`;
    return this.http.get<PlanSalud[]>(URL, { withCredentials: true }).pipe();
  }

  public getMunicipio(idCiudad: string): Observable<Municipio[]> {
    const URL = `${this.url}${this.port}/api_ingreso/maestros/${MaestrosEnum.municipios}/${idCiudad}`;
    return this.http.get<Municipio[]>(URL, { withCredentials: true }).pipe();
  }

  public getUsuarios(): Observable<Usuario[]> {
    const URL = `${this.url}${this.port}/api_ingreso/maestros/usuarios`;
    return this.http.get<Usuario[]>(URL, { withCredentials: true }).pipe();
  }

  public getTiposCasoCovid(): Observable<any[]> {
    const URL = `${this.url}${this.port}/api_ingreso/maestros/tiposCasoCovid`;
    return this.http.get<any[]>(URL, { withCredentials: true }).pipe();
  }

  public getTiposSondaje(): Observable<TipoSondajeIngreso[]> {
    const URL = `${this.url}${this.port}/api_ingreso/maestros/tiposSondaje`;
    return this.http
      .get<TipoSondajeIngreso[]>(URL, { withCredentials: true })
      .pipe();
  }

  public getViasAdministracion(tipo: string): Observable<ViaAdministracion[]> {
    const URL = `${this.url}${this.port}/api_ingreso/maestros/viasAdministracion/${tipo}`;
    return this.http
      .get<ViaAdministracion[]>(URL, { withCredentials: true })
      .pipe();
  }

  ///// Novedades ////

  public getMotivosEgresoNovedad(): Observable<MotivoEgreso[]> {
    const URL = `${this.url}${this.port}/api_novedades/maestros/motivosEgreso`;
    return this.http.get<MotivoEgreso[]>(URL, { withCredentials: true }).pipe();
  }

  public getViasAdministracionNovedad(
    tipo: string,
  ): Observable<ViaAdministracion[]> {
    const URL = `${this.url}${this.port}/api_novedades/maestros/viasAdministracion/${tipo}`;
    return this.http
      .get<ViaAdministracion[]>(URL, { withCredentials: true })
      .pipe();
  }

  public getMotivosFijacionCita(): Observable<MotivoFijarCita[]> {
    const URL = `${this.url}${this.port}/api_novedades/maestros/motivosFijarCitas`;
    return this.http
      .get<MotivoFijarCita[]>(URL, { withCredentials: true })
      .pipe();
  }

  public getMotivosCancelacionCitaNovedad(): Observable<MotivosNoAdmision[]> {
    const URL = `${this.url}${this.port}/api_novedades/maestros/motivosCancelacion`;
    return this.http
      .get<MotivosNoAdmision[]>(URL, { withCredentials: true })
      .pipe();
  }

  public getTipoAtencionPorCodigo(
    codigoTipo: number,
  ): Observable<TipoAtencion[]> {
    const url = `${this.url}${this.port}/api_ingreso/maestros/tipoAtencionPorCodigoTipo/${codigoTipo}`;
    return this.http.get<TipoAtencion[]>(url, { withCredentials: true }).pipe();
  }

  public getTipoPrestacionPorServicio(
    tipoServicio: number,
  ): Observable<TipoPrestacion[]> {
    const url = `${this.url}${this.port}/api_ingreso/maestros/tipoPrestacionPorServicio/${tipoServicio}`;
    return this.http
      .get<TipoPrestacion[]>(url, { withCredentials: true })
      .pipe();
  }

  public getPisoPorCiudadProgramaPrestacion(
    idCiudad: string,
    idPrograma: string,
    idTipoPrestacion: string,
  ): Observable<ConfiguracionInferirPiso> {
    const url = `${this.url}${this.port}/api_ingreso/maestros/piso/${idCiudad}/${idPrograma}/${idTipoPrestacion}`;
    return this.http
      .get<ConfiguracionInferirPiso>(url, { withCredentials: true })
      .pipe();
  }

  public getZonasPorPiso(idPiso: string): Observable<ZonasPorPiso> {
    const url = `${this.url}${this.port}/api_ingreso/maestros/zonas/${idPiso}`;
    return this.http.get<ZonasPorPiso>(url, { withCredentials: true }).pipe();
  }

  public getPisoPorId(idPiso: string): Observable<Piso> {
    const url = `${this.url}${this.port}/api_ingreso/maestros/pisos/${idPiso}`;
    return this.http.get<Piso>(url, { withCredentials: true }).pipe();
  }

  public getConductaPorId(idConducta: string): Observable<Conducta> {
    const url = `${this.url}${this.port}/api_ingreso/maestros/conductaPorId/${idConducta}`;
    return this.http.get<Conducta>(url, { withCredentials: true }).pipe();
  }

  public getSlaPorPlanSaludPrestacion(
    idPlanSalud: string,
    idTipoPrestacion: string,
  ): Observable<ConfiguracionInferirSLA[]> {
    const url = `${this.url}${this.port}/api_ingreso/maestros/slaPorPlanSaludPrestacion/${idPlanSalud}/${idTipoPrestacion}`;
    return this.http
      .get<ConfiguracionInferirSLA[]>(url, { withCredentials: true })
      .pipe();
  }
}
